import React from "react";
import { panelFieldLabelClassName } from "../propertyPanelUtils";
import NumberField from "./NumberField";

type ObjectRotationFieldProps = {
  label: string;
  value: number | string;
  placeholder?: string;
  onChange: (value: string) => void;
};

const ObjectRotationField: React.FC<ObjectRotationFieldProps> = ({
  label,
  value,
  placeholder,
  onChange,
}) => (
  <NumberField
    label={label}
    value={value}
    placeholder={placeholder}
    fieldClassName="block min-w-0"
    labelClassName={panelFieldLabelClassName}
    inputClassName="h-8 w-full min-w-0 rounded-sm border border-gray-300 bg-gray-50 px-1.5 py-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500"
    onChange={onChange}
  />
);

export default ObjectRotationField;
